<template>
  <div>
    <h5 class="text-primary mt-4">CORRECCIÓN DE DATOS PERSONALES</h5>
    <b-card border-variant="light">
      <b-row>
        <b-col sm="3">
          <b-form-checkbox class="mt-2" v-model="chk.nombre" name="check-button" switch>Nombre</b-form-checkbox>
        </b-col>
        <b-col sm="5">
          <b-input
            v-model="datos.nombre"
            :disabled="!chk.nombre"
            type="text"
            placeholder="Ingrese Nombre"
            @blur="$v.datos.nombre.$touch"
            :state="$v.datos.nombre.$dirty && chk.nombre ? !$v.datos.nombre.$error : null"
          ></b-input>
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col sm="3">
          <b-form-checkbox class="mt-2" v-model="chk.apellido" name="check-button" switch>Apellido</b-form-checkbox>
        </b-col>
        <b-col sm="5">
          <b-input
            v-model="datos.apellido"
            :disabled="!chk.apellido"
            type="text"
            placeholder="Ingrese Apellido"
            @blur="$v.datos.apellido.$touch"
            :state="$v.datos.apellido.$dirty && chk.apellido ? !$v.datos.apellido.$error : null"
          ></b-input>
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col sm="3">
          <b-form-checkbox class="mt-2" v-model="chk.dni" name="check-button" switch>DNI / CUIL</b-form-checkbox>
        </b-col>
        <b-col sm="5">
          <b-input
            v-model="datos.dni"
            :disabled="!chk.dni"
            type="text"
            placeholder="Ingrese DNI / CUIL"
            @blur="$v.datos.dni.$touch"
            :state="$v.datos.dni.$dirty && chk.dni ? !$v.datos.dni.$error : null"
          ></b-input>
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col sm="3">
          <b-form-checkbox class="mt-2" v-model="chk.email" name="check-button" switch>E-Mail</b-form-checkbox>
        </b-col>
        <b-col sm="5">
          <b-input
            v-model="datos.email"
            :disabled="!chk.email"
            type="text"
            placeholder="Ingrese E-Mail"
            @blur="$v.datos.email.$touch"
            :state="$v.datos.email.$dirty && chk.email ? !$v.datos.email.$error : null"
          ></b-input>
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col sm="3">
          <b-form-checkbox
            class="mt-2"
            v-model="chk.fechaNacimiento"
            name="check-button"
            switch
          >Fecha de Nacimiento</b-form-checkbox>
        </b-col>
        <b-col sm="5">
          <b-input
            v-mask="'##/##/####'"
            v-model="datos.fechaNacimiento"
            :disabled="!chk.fechaNacimiento"
            type="text"
            placeholder="dd/mm/aaaa"
            @blur="$v.datos.fechaNacimiento.$touch"
            :state="$v.datos.fechaNacimiento.$dirty && chk.fechaNacimiento ? !$v.datos.fechaNacimiento.$error : null"
          ></b-input>
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col sm="3">
          <b-form-checkbox class="mt-2" v-model="chk.telefono" name="check-button" switch>Teléfono</b-form-checkbox>
        </b-col>
        <b-col sm="5">
          <b-input
            v-model="datos.telefono"
            :disabled="!chk.telefono"
            type="text"
            placeholder="Ingrese Teléfono"
            @blur="$v.datos.telefono.$touch"
            :state="$v.datos.telefono.$dirty && chk.telefono ? !$v.datos.telefono.$error : null"
          ></b-input>
        </b-col>
      </b-row>
    </b-card>
    <div class="submit-footer">
      <b-row>
        <b-col class="text-right">
          <b-btn
            variant="success"
            @click="submit"
            v-b-tooltip.hover
            title="La presente solicitud está sujeta a aprobación. Los cambios no se guardarán de manera instantánea."
          >
            <i class="fa fa-send-o" v-if="!sending"></i>
            <i class="fa fa-spinner fa-spin" v-else></i>
            Enviar Solicitud
          </b-btn>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import DomicilioForm from './../DomicilioForm';
import { requiredIf, email } from 'vuelidate/lib/validators';

export default {
  name: 'EndosoCambioDomicilio',
  components: {
    DomicilioForm
  },
  props: ['nroPoliza', 'asegurado', 'tomador'],
  data() {
    return {
      sending: false,
      chk: {
        nombre: false,
        apellido: false,
        dni: false,
        email: false,
        telefono: false,
        fechaNacimiento: false
      },
      datos: {
        nombre: '',
        apellido: '',
        dni: '',
        email: '',
        telefono: '',
        fechaNacimiento: ''
      }
    };
  },
  validations: {
    datos: {
      nombre: {
        required: requiredIf(function() {
          return this.chk.nombre;
        })
      },
      apellido: {
        required: requiredIf(function() {
          return this.chk.apellido;
        })
      },
      dni: {
        required: requiredIf(function() {
          return this.chk.dni;
        })
      },
      email: {
        required: requiredIf(function() {
          return this.chk.email;
        }),
        email
      },
      telefono: {
        required: requiredIf(function() {
          return this.chk.telefono;
        })
      },
      fechaNacimiento: {
        required: requiredIf(function() {
          return this.chk.fechaNacimiento;
        })
      }
    }
  },
  methods: {
    submit: async function() {
      this.$v.datos.$touch();

      if (this.$v.datos.$invalid) {
        this.$toast.error('Revise los campos indicados');
        return null;
      }

      if (!this.asegurado) {
        this.$toast.error('Seleccione el asegurado');
        return null;
      }

      const payload = {
        asegurado: this.asegurado.text,
        datos: {},
        pas: {
          nombre: (this.$store.state.auth.nombre + ' ' + this.$store.state.auth.apellido).replace('null',''),
          codigo: this.$store.state.auth.cod_agente,
          email: this.$store.state.auth.email
        },
        poliza: this.nroPoliza
      };

      for (const key in this.chk) {
        if (this.chk[key]) {
          payload.datos[key] = this.datos[key];
        }
      }

      if (!Object.values(payload.datos).length) {
        this.$toast.error('Debe completar al menos un campo de los datos personales.');
        return null;
      }

      this.sending = true;
      await this.$api
        .post(`endoso/solicitud/cambio-datos-personales/${this.tomador}`, payload)
        .then(() => {
          this.$toast.success('Solicitud de cambio de datos personales enviada existosamente.');
        })
        .catch(err => {
          //console.log(err.response);
          this.$toast.error('Ocurrió un error y la solicitud no pudo ser enviada.');
        });
      this.sending = false;
    }
  }
};
</script>
